import { render, staticRenderFns } from "./ProlongLicencesSetup.vue?vue&type=template&id=551cf90c&"
import script from "./ProlongLicencesSetup.vue?vue&type=script&lang=js&"
export * from "./ProlongLicencesSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('551cf90c')) {
      api.createRecord('551cf90c', component.options)
    } else {
      api.reload('551cf90c', component.options)
    }
    module.hot.accept("./ProlongLicencesSetup.vue?vue&type=template&id=551cf90c&", function () {
      api.rerender('551cf90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LicenceSetup/ProlongLicencesSetup.vue"
export default component.exports